import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=225cbcd1&scoped=true"
import script from "./commentList.vue?vue&type=script&lang=ts"
export * from "./commentList.vue?vue&type=script&lang=ts"
import style0 from "./commentList.vue?vue&type=style&index=0&id=225cbcd1&prod&lang=scss"
import style1 from "./commentList.vue?vue&type=style&index=1&id=225cbcd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225cbcd1",
  null
  
)

export default component.exports